<template>
    <div>
        <b-form style="width: 100%;" @submit="onSubmit" @reset="onReset" v-if="show"
                class="text-left align-bottom">
            <b-form-row>
                <b-col cols="3">
                    <label for="name" size="sm">{{ $t("form-name") }}:</label>
                </b-col>
                <b-col cols="9">
                    <b-form-input required id="name" size="sm" v-model="form.name"></b-form-input>
                </b-col>
            </b-form-row>
            <b-form-row>
                <b-col cols="3">
                    <label for="address" size="sm">{{ $t("form-address") }}:</label>
                </b-col>
                <b-col cols="9">
                    <b-form-textarea required id="address" rows="3" max-rows="3" size="sm"
                                     v-model="form.address"></b-form-textarea>
                </b-col>
            </b-form-row>
            <b-form-row>
                <b-col cols="3">
                    <label for="mail" size="sm">{{ $t("form-mail") }}:</label>
                </b-col>
                <b-col>
                    <b-form-input id="mail" size="sm" type="email" class="mt-0" v-model="form.email"></b-form-input>
                </b-col>
            </b-form-row>
            <b-form-row>
                <b-col cols="3">
                    <label for="phone" size="sm">{{ $t("form-phone") }}:</label>
                </b-col>
                <b-col>
                    <b-form-input id="phone" required size="sm" v-model="form.phone"></b-form-input>
                </b-col>
            </b-form-row>
            <b-form-row v-if="amazon === true">
                <b-col cols="3">
                    <label for="phone" size="sm">{{ $t("worked-for-amazon-question") }}:</label>
                </b-col>
                <b-col>
                    <b-form-group class="pt-3">
                        <b-form-radio required inline v-model="form.amazon" name="amazon-radio" value="yes">{{ $t("form-yes") }}</b-form-radio>
                        <b-form-radio required inline v-model="form.amazon" name="amazon-radio" value="no">{{ $t("form-no") }}</b-form-radio>
                    </b-form-group>
                </b-col>
            </b-form-row>
            <b-form-row v-if="amazon === true">
                <b-col cols="3">
                    <label for="amazoncompany" size="sm">{{ $t("worked-for-amazon-company") }}:</label>
                </b-col>
                <b-col>
                    <b-form-input id="amazoncompany" size="sm" v-model="form.amazoncompany"></b-form-input>
                </b-col>
            </b-form-row>
            <!--<b-form-row>
                <b-col cols="3">
                    <label for="message" size="sm">Nachricht:</label>
                </b-col>
                <b-col>
                    <b-form-textarea required id="message" rows="3" max-rows="6" size="sm"
                                     v-model="form.message"></b-form-textarea>
                </b-col>
            </b-form-row>-->
                <b-button v-if="success !== true" class="float-right mt-2 mb-0" type="submit">{{ $t("button-send") }}</b-button>
                <b-button v-if="success === true" disabled variant="success" class="float-right mt-2 mb-0" @click="onSubmit">{{ $t("button-success") }}</b-button>
        </b-form>
    </div>
</template>

<script>
    export default {
        name: "JobForm",
        props: {
            jobtitle: String,
            station: String,
            amazon: Boolean
        },
        data() {
            return {
                show: true,
                form: {},
                success: false
            }
        },
        methods: {
            onSubmit(event) {
                event.preventDefault();
                let currentObj = this;
                this.axios.post('post.php', {
                    data: {
                        jobtitle: this.jobtitle,
                        station: this.station,
                        form: this.form
                    }
                }).then(function () {
                    currentObj.success = true;
                    currentObj.onReset(event);
                }).catch(function () {
                    currentObj.success = false;
                });
            },
            onReset(event) {
                event.preventDefault();
                this.form = Object.assign({}, this.emptyform);
                this.show = false;
                this.$nextTick(() => {
                    this.show = true
                })
            },
        }
    }
</script>

<style scoped>

</style>

<i18n>
    {
        "de": {
            "form-name": "Name",
            "form-address": "Adresse",
            "form-mail": "E-Mail",
            "form-phone": "Telefon",
            "form-yes": "Ja",
            "form-no": "Nein",
            "worked-for-amazon-question": "Haben sie schon für Amazon gearbeitet?",
            "worked-for-amazon-company": "Falls Ja, für welches Unternehmen",
            "button-send": "Absenden",
            "button-success": "Erfolgreich"
        },
        "gb": {
            "form-name": "Name",
            "form-address": "Address",
            "form-mail": "E-Mail",
            "form-phone": "Phone",
            "form-yes": "Yes",
            "form-no": "No",
            "worked-for-amazon-question": "Did you already work for Amazon?",
            "worked-for-amazon-company": "If yes, for which company",
            "button-send": "Send",
            "button-success": "Success"
        },
        "ro": {
            "form-name": "Nume",
            "form-address": "Adresa",
            "form-mail": "E-Mail",
            "form-phone": "Telefon",
            "form-yes": "Da",
            "form-no": "Nu",
            "worked-for-amazon-question": "Ați lucrat deja pentru Amazon?",
            "worked-for-amazon-company": "Dacă da, pentru ce companie",
            "button-send": "Trimite",
            "button-success": "Succes"
        },
        "bg": {
            "form-name": "Име",
            "form-address": "Адрес",
            "form-mail": "Електронна поща",
            "form-phone": "Телефон",
            "form-yes": "Да",
            "form-no": "Не",
            "worked-for-amazon-question": "Работихте ли за Амазонка?",
            "worked-for-amazon-company": "Ако да, за коя фирма",
            "button-send": "Изпрати",
            "button-success": "Успешно"
        }
    }
</i18n>
